import './modules/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';

import './modules/global-jquery';
import './modules/shop';

import './modules/product-modal';

import 'bootstrap';

import * as feather from 'feather-icons';

import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
    // See https://www.npmjs.com/package/@crasman/branch-bar for settings
    branchBar.init();

    feather.replace();

    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach(container => {
        new Swiper(container, {
            direction: 'horizontal',
            slidesPerView: 1,
        });
    });
});
